import { Maybe, Undef } from 'types/UtilityTypes';
import { TMS } from 'types/enums/Integrations';

import {
  LTLRateCardCoverageConfig,
  LTLRateCardCoverageMode,
} from '../LTLRateCardCoverage';

export const TAI_LIMITED_LIABILITY_COVERAGE_CONFIG: LTLRateCardCoverageConfig =
  {
    sectionTitle: 'Total liability',
    defaultOpen: false,
    mode: LTLRateCardCoverageMode.LimitedLiability,
  };

export function getTaiLimitedLiabilityCoverageConfig(
  quoteSource?: Maybe<string>,
  hideLimitedLiability = false
): Undef<LTLRateCardCoverageConfig> {
  if (quoteSource?.toLowerCase() !== TMS.Tai || hideLimitedLiability) {
    return undefined;
  }

  return TAI_LIMITED_LIABILITY_COVERAGE_CONFIG;
}
